<template>
	<div :class="{ 'button-wrap': true, 'single-brand': singleBrand, ['count-' + brandButtons.length]: true, landscape: !singleBrand }">
		<span
			v-for="(buttonType, index) in brandButtons"
			:key="'button-' + index"
			:class="[
				{
					message: !!buttonType.message,
					button: !buttonType.message,
					'no-margin': !buttonType.message,
					'no-case': !buttonType.message,
					'flip-colours': index === 0,
					hollow: index > 0 && !buttonType.message && !buttonClasses(buttonType).hasClass,
					//white: index > 0 && !buttonType.message && singleBrand && !buttonClasses(buttonType).hasClass,
					[buttonType]: true,
				},
				buttonClasses(buttonType).class,
			]"
			@click="!!buttonType.message ? null : action($event, brand.brand_id, buttonType, false)"
			v-html="!!buttonType.message ? buttonType.message : buttons.labels[buttonType]" />
	</div>
</template>

<script>
import { computed } from "vue";
import general from "./../../utils/general";
export default {
	name: "BrandActionButtons",
	props: {
		buttonDefaults: {
			type: Object,
		},
		brand: {
			type: Object,
		},
		singleBrand: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { emit }) {
		const buttons = computed(() => {
			let btnInfo = {};

			if (props.buttonDefaults) {
				Object.keys(props.buttonDefaults).forEach((key) => {
					let info = props.buttonDefaults[key];
					btnInfo[key] = {};

					Object.keys(info).forEach((k) => {
						btnInfo[key][k] = null;

						if (typeof info[k] === "string" || Array.isArray(info[k])) {
							btnInfo[key][k] = info[k];
						} else if (typeof info[k] === "object" && !!props.brand) {
							if (info[k][props.brand.connectType]) {
								btnInfo[key][k] = info[k][props.brand.connectType];
							}
						}
					});
				});
			}

			if (!!props.brand && !!props.brand.buttons) {
				Object.keys(props.brand.buttons).forEach((key) => {
					let info = props.brand.buttons[key];
					if (!btnInfo[key]) btnInfo[key] = {};
					Object.keys(info).forEach((k) => {
						if (typeof info[k] === "string" || Array.isArray(info[k])) {
							btnInfo[key][k] = info[k];
						} else if (typeof info[k] === "object" && !!props.brand) {
							if (info[k][props.brand.connectType]) {
								btnInfo[key][k] = info[k][props.brand.connectType];
							}
						}
					});
				});
			}

			return btnInfo;
		});

		const brandButtons = computed(() => {
			if (props.brand && buttons.value && buttons.value.types) {
				let s =
					props.brand.bookmarked && ["declined-auto", "declined"].indexOf(props.brand.status) === -1 ? "bookmarked" : props.brand.status;
				let b = buttons.value.types[s] ? general.stripObject(buttons.value.types[s]) : [];

				if (b.length > 0 && Array.isArray(b[0])) {
					b = props.singleBrand ? b[1] : b[0];
				}

				if (props.singleBrand && buttons.value.footerMessages && buttons.value.footerMessages[s]) {
					b.splice(1, 0, { message: buttons.value.footerMessages[s] });
				}

				return b;
			}
			return [];
		});

		const action = (event, brandId, actionType, forceIt) => {
			event.stopPropagation();
			emit("action", { brandId, action: actionType, forceIt });
		};

		const buttonClasses = (buttonType) => {
			let c = { hasClass: false, class: {} };
			if (buttons.value && buttons.value.buttonClasses && buttons.value.buttonClasses[buttonType]) {
				c.hasClass = true;
				c.class[buttons.value.buttonClasses[buttonType]] = true;
			}
			return c;
		};

		return {
			buttons,
			brandButtons,
			action,
			buttonClasses,
		};
	},
};
</script>

<style lang="less" scoped>
@import "./../../assets/css/less/_helper.less";
@import "./../../assets/css/less/_settings.less";
.button-wrap {
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;

	&.single-brand {
		width: 100%;
		background: #fff;
		padding: 0;
		gap: 6px;
		flex-wrap: nowrap;
		box-sizing: border-box;
		justify-content: space-evenly;
		.box-shadow(1px 1px 25px -7px rgba(255,255,255,0.35));

		.message {
			padding: 2px 20px 0 0;
			margin: 0;
			font-weight: 400;
			font-size: 16px;
			display: inline-block;
		}

		.button {
			font-size: 14px;
		}
	}

	.button {
		flex: 1 1 100%;

		&:first-child {
			margin-top: 0;
		}
	}

	&.landscape {
		margin: 20px 15px 0;
	}
}

@media (min-width: 568px) {
	.button-wrap {
		width: 100%;
		gap: 20px;

		.button {
			flex: none;
			margin-top: 0;
		}
	}
}
@media (min-width: 768px) {
	.button-wrap {
		&.single-brand {
			.button {
				font-size: 16px;
			}
		}

		&.landscape {
			margin-top: 10px;
			margin-left: 0;
			margin-right: 0;
		}
	}
}
</style>